import { h } from "preact";

export const StoryAuthorLink = ({ story }) => <a href={`https://news.ycombinator.com/user?id=${story.by}`}>{story.by}</a>;
